export var EOAuthType;
(function (EOAuthType) {
    EOAuthType["Dropbox"] = "dropbox";
    EOAuthType["Twitter"] = "twitter";
    EOAuthType["Google"] = "google";
    EOAuthType["ProtonMail"] = "protonmail";
    EOAuthType["Oura"] = "oura";
    EOAuthType["EightSleep"] = "eight_sleep";
    EOAuthType["Renpho"] = "renpho";
})(EOAuthType || (EOAuthType = {}));
export var EOAuthFlowType;
(function (EOAuthFlowType) {
    EOAuthFlowType["OAuthRedirect"] = "oauth_redirect";
    EOAuthFlowType["CredentialsForm"] = "credentials_form";
})(EOAuthFlowType || (EOAuthFlowType = {}));
//# sourceMappingURL=oauth.enum.js.map